const routesUrl: Record<string, string> = {
  dashboard: '/',
  shipping: '/shipping',
  carrierGuide: '/carrier-guide',
  routeGuide: '/route-guide'
};

export default routesUrl;
